// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wB4LV","content":"styles_content__2RjTb","row":"styles_row__Jue9r","footer":"styles_footer__2xcIe","phraseLength":"styles_phraseLength__Jbpuv"};